// extracted by mini-css-extract-plugin
module.exports = {"body":"HeaderAuth_body__3zxaH","block":"HeaderAuth_block__1Ks_3","logo":"HeaderAuth_logo__33bFn","text_glav":"HeaderAuth_text_glav__2UB3T"};